import script from "./BaseMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseMenu.vue?vue&type=script&setup=true&lang=ts"

import "./BaseMenu.vue?vue&type=style&index=0&id=060fcbec&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-060fcbec"]])

export default __exports__